var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_172_850)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.2193,
    y: 2,
    width: 60,
    height: 60,
    rx: 16,
    fill: "white",
    fillOpacity: 0.07,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.7193,
    y: 2.5,
    width: 59,
    height: 59,
    rx: 15.5,
    stroke: "url(#paint0_linear_172_850)",
    strokeOpacity: 0.23,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.3439 21.875H22.0939C21.1988 21.875 20.3403 22.2306 19.7074 22.8635C19.0745 23.4965 18.7189 24.3549 18.7189 25.25V41C18.7189 41.8951 19.0745 42.7536 19.7074 43.3865C20.3403 44.0194 21.1988 44.375 22.0939 44.375H42.3439C43.239 44.375 44.0974 44.0194 44.7304 43.3865C45.3633 42.7536 45.7189 41.8951 45.7189 41V25.25C45.7189 24.3549 45.3633 23.4965 44.7304 22.8635C44.0974 22.2306 43.239 21.875 42.3439 21.875ZM37.2814 39.875H27.1564C26.4105 39.875 25.6951 39.5787 25.1676 39.0512C24.6402 38.5238 24.3439 37.8084 24.3439 37.0625C24.3439 36.3166 24.6402 35.6012 25.1676 35.0738C25.6951 34.5463 26.4105 34.25 27.1564 34.25H37.2814C38.0273 34.25 38.7427 34.5463 39.2701 35.0738C39.7976 35.6012 40.0939 36.3166 40.0939 37.0625C40.0939 37.8084 39.7976 38.5238 39.2701 39.0512C38.7427 39.5787 38.0273 39.875 37.2814 39.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3452 20.75H33.3452V16.25C33.3452 15.9516 33.2267 15.6655 33.0157 15.4545C32.8047 15.2435 32.5186 15.125 32.2202 15.125C31.9218 15.125 31.6357 15.2435 31.4247 15.4545C31.2137 15.6655 31.0952 15.9516 31.0952 16.25V20.75H22.0952C20.9017 20.75 19.7571 21.2241 18.9132 22.068C18.0693 22.9119 17.5952 24.0565 17.5952 25.25V41C17.5952 42.1935 18.0693 43.3381 18.9132 44.182C19.7571 45.0259 20.9017 45.5 22.0952 45.5H42.3452C43.5387 45.5 44.6833 45.0259 45.5272 44.182C46.3711 43.3381 46.8452 42.1935 46.8452 41V25.25C46.8452 24.0565 46.3711 22.9119 45.5272 22.068C44.6833 21.2241 43.5387 20.75 42.3452 20.75ZM44.5952 41C44.5952 41.5967 44.3582 42.169 43.9362 42.591C43.5142 43.0129 42.942 43.25 42.3452 43.25H22.0952C21.4985 43.25 20.9262 43.0129 20.5042 42.591C20.0823 42.169 19.8452 41.5967 19.8452 41V25.25C19.8452 24.6533 20.0823 24.081 20.5042 23.659C20.9262 23.2371 21.4985 23 22.0952 23H42.3452C42.942 23 43.5142 23.2371 43.9362 23.659C44.3582 24.081 44.5952 24.6533 44.5952 25.25V41ZM24.3452 29.1875C24.3452 28.8537 24.4442 28.5275 24.6296 28.25C24.815 27.9725 25.0786 27.7562 25.3869 27.6285C25.6953 27.5007 26.0346 27.4673 26.3619 27.5324C26.6893 27.5975 26.99 27.7583 27.226 27.9943C27.462 28.2303 27.6227 28.5309 27.6878 28.8583C27.7529 29.1856 27.7195 29.5249 27.5918 29.8333C27.464 30.1416 27.2477 30.4052 26.9702 30.5906C26.6927 30.776 26.3665 30.875 26.0327 30.875C25.5852 30.875 25.1559 30.6972 24.8395 30.3807C24.523 30.0643 24.3452 29.6351 24.3452 29.1875ZM36.7202 29.1875C36.7202 28.8537 36.8192 28.5275 37.0046 28.25C37.19 27.9725 37.4536 27.7562 37.7619 27.6285C38.0703 27.5007 38.4096 27.4673 38.7369 27.5324C39.0643 27.5975 39.365 27.7583 39.601 27.9943C39.837 28.2303 39.9977 28.5309 40.0628 28.8583C40.1279 29.1856 40.0945 29.5249 39.9668 29.8333C39.839 30.1416 39.6227 30.4052 39.3452 30.5906C39.0677 30.776 38.7415 30.875 38.4077 30.875C37.9602 30.875 37.5309 30.6972 37.2145 30.3807C36.898 30.0643 36.7202 29.6351 36.7202 29.1875ZM37.2827 33.125H27.1577C26.1134 33.125 25.1119 33.5398 24.3735 34.2783C23.6351 35.0167 23.2202 36.0182 23.2202 37.0625C23.2202 38.1068 23.6351 39.1083 24.3735 39.8467C25.1119 40.5852 26.1134 41 27.1577 41H37.2827C38.327 41 39.3285 40.5852 40.067 39.8467C40.8054 39.1083 41.2202 38.1068 41.2202 37.0625C41.2202 36.0182 40.8054 35.0167 40.067 34.2783C39.3285 33.5398 38.327 33.125 37.2827 33.125ZM33.9077 35.375V38.75H30.5327V35.375H33.9077ZM25.4702 37.0625C25.4702 36.6149 25.648 36.1857 25.9645 35.8693C26.2809 35.5528 26.7102 35.375 27.1577 35.375H28.2827V38.75H27.1577C26.7102 38.75 26.2809 38.5722 25.9645 38.2557C25.648 37.9393 25.4702 37.5101 25.4702 37.0625ZM37.2827 38.75H36.1577V35.375H37.2827C37.7303 35.375 38.1595 35.5528 38.476 35.8693C38.7924 36.1857 38.9702 36.6149 38.9702 37.0625C38.9702 37.5101 38.7924 37.9393 38.476 38.2557C38.1595 38.5722 37.7303 38.75 37.2827 38.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_172_850",
    x: 0.855663,
    y: 0.636364,
    width: 62.7273,
    height: 62.7273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.36364,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_172_850"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.527306 0 0 0 0 0.527306 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_172_850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_172_850",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_850",
    x1: 6.9171,
    y1: 2,
    x2: 77.527,
    y2: 23.2953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardInfoIcon);
export default __webpack_public_path__ + "static/media/CardInfoIcon.5b66089b7f8ef0acbfe682b0aeb7355f.svg";
export { ForwardRef as ReactComponent };